export default __webpack_public_path__ + "static/media/img-0760-slovenia-full-face.3da11ddb.png";